import { couponActionTypes, userActionTypes } from '../actions/types';
import { couponService } from '../services';
import _ from 'lodash';

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};

const findAll = () => {
  return (dispatch, getState) => {
    dispatch(request());

    couponService.findAll().then(
      coupons => {
        dispatch(success(coupons));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            couponActionTypes.GET_ALL_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: couponActionTypes.GET_ALL_REQUEST };
  }
  function success(coupons) {
    return { type: couponActionTypes.GET_ALL_SUCCESS, coupons };
  }
};

const create = coupon => {
  return (dispatch, getState) => {
    dispatch(request());

    couponService.create(coupon).then(
      coupon => {
        dispatch(success(coupon));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            couponActionTypes.CREATE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: couponActionTypes.CREATE_REQUEST };
  }
  function success(coupon) {
    return { type: couponActionTypes.CREATE_SUCCESS, coupon };
  }
}



export const couponActions = {
  findAll,
  create,
};
